import React from 'react';
import {classes, style} from './doppe-action-type-link-view-widget.st.css';
import {ButtonType} from '@wix/devzai-utils-react';
import {doppeHideableValueIsHidden} from '../../../client-server-common/types/doppe-hideable-value';
import {
    DoppeActionTypeWidgetInnerButton
} from '../../../components/doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    CouponSourceType,
    DoppeActionTypeCouponView
} from '../../../components/doppe-action-type-coupon-view/doppe-action-type-coupon-view';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {DoppeActionTypeLinkView} from '../doppe-action-type-link-view';
import {arrayFirst, asArray, HtmlObjectResizeMode} from '@wix/devzai-utils-common';
import {DoppePageMediaView} from '../../../components/doppe-page-media-view/doppe-page-media-view';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapper
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper/doppe-action-type-widget-content-layout-new-wrapper';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';


export const DoppeActionTypeLinkViewWidget = React.memo(function DoppeActionTypeLinkWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeLinkView.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            <DoppeActionTypeLinkWidgetInner
                reportGoalAchieved={() => {
                    actionContext.reportGoalAchieved()
                }}
                actionId={actionContext.action.id}
                actionSettings={actionContext.action.settings}
            />
        </DoppeActionTypeWidgetLayout>
    );
});


export const DoppeActionTypeLinkWidgetInner = React.memo(function DoppeActionTypeLinkWidgetInner(
    props: {
        actionSettings: DoppeActionTypeLinkView.ActionSettings;
        reportGoalAchieved: () => void;
        actionId: string;
    }
) {
    const {
        actionSettings,
        reportGoalAchieved,
        actionId,
    } = props;

    const {
        linkButtonText,
        url,
        description,
        title,
        couponCode,
        image,
    } = actionSettings;

    const firstImage = image ? arrayFirst(asArray(image)) : null;

    return (
        <DoppeActionTypeWidgetContentLayoutNewWrapper
            fullWidthMainMedia={true}
            mainMedia={firstImage ? (
                <div
                    className={style(classes.imageContainer, {})}
                >
                    <DoppePageMediaView
                        className={style(classes.image, {})}
                        mediaResource={firstImage}
                        layoutSpec={{autoHeight: true, maxHeight: 360}}
                        widthSpec={{contentRelativeWidth: 1}}
                        mediaResizeMode={HtmlObjectResizeMode.Cover}
                    />
                </div>
            ) : null}
            footer={(
                <DoppeActionTypeWidgetInnerButton
                    buttonType={ButtonType.NormalButton}
                    tagName={'a'}
                    href={url}
                    target={'_blank'}
                    onClick={() => {
                        reportGoalAchieved();
                    }}
                >
                    {linkButtonText}
                </DoppeActionTypeWidgetInnerButton>
            )}
        >
            <DoppeActionTypeWidgetInnerTitle>
                {title}
            </DoppeActionTypeWidgetInnerTitle>

            <DoppeActionTypeWidgetInnerDescription
                className={style(classes.couponDescription, {})}
            >
                {description}
            </DoppeActionTypeWidgetInnerDescription>
            {
                !doppeHideableValueIsHidden(couponCode) ?
                    <DoppeActionTypeCouponView
                        className={style(classes.couponView, {})}
                        coupon={couponCode}
                        couponSourceType={CouponSourceType.Action}
                        actionId={actionId}
                    />
                    :
                    null
            }
        </DoppeActionTypeWidgetContentLayoutNewWrapper>
    );
});